module.exports = __webpack_public_path__ + "media/images/default/join_us/recruit_mobile-9b2ff0507501b81a9b0dea05ff07e499.jpg";